
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("d54uY", function(module, exports) {
/* AdminAnnouncementBannerComponent.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

var $7sObp = parcelRequire("7sObp");


var $aXWIB = parcelRequire("aXWIB");


var $4KS7f = parcelRequire("4KS7f");


var $4FxUL = parcelRequire("4FxUL");


var $ibzAc = parcelRequire("ibzAc");


var $6fjxX = parcelRequire("6fjxX");


var $67O0h = parcelRequire("67O0h");


var $kvJHJ = parcelRequire("kvJHJ");


var $32x2E = parcelRequire("32x2E");


var $luv00 = parcelRequire("luv00");


var $9eE57 = parcelRequire("9eE57");


var $5Abqh = parcelRequire("5Abqh");


var $aTfTn = parcelRequire("aTfTn");


var $ggElv = parcelRequire("ggElv");


var $3nZRM = parcelRequire("3nZRM");


var $7whYF = parcelRequire("7whYF");


var $b3o7x = parcelRequire("b3o7x");

const $95edbd031597fc42$var$i18n = (0, $aXWIB.defineMessages)({
    dismiss: {
        id: "admin-announcement-banner.dismiss.button",
        defaultMessage: "Dismiss admin announcement banner"
    },
    dismissText: {
        id: "admin-announcement-banner.dismiss.button.text",
        defaultMessage: "Close"
    },
    previewDismiss: {
        id: "admin-announcement-banner.preview-dismiss.aria-label",
        defaultMessage: "Close admin announcement banner"
    }
});
var $95edbd031597fc42$export$40bdb27f2137fcf = /*#__PURE__*/ function(Appearance) {
    Appearance["ANNOUNCEMENT"] = "announcement";
    Appearance["INFO"] = "info";
    Appearance["NOTE"] = "note";
    Appearance["SUCCESS"] = "success";
    Appearance["WARNING"] = "warning";
    Appearance["ERROR"] = "error";
    return Appearance;
}({});
const $95edbd031597fc42$export$1cd228c2a1902afd = {
    announcement: "var(--ds-background-neutral-bold, #292A2E)",
    info: "var(--ds-background-accent-blue-bolder, #1868DB)",
    note: "var(--ds-background-accent-purple-bolder, #964AC0)",
    success: "var(--ds-background-accent-green-bolder, #1F845A)",
    warning: "var(--ds-background-accent-yellow-subtle, #EED12B)",
    error: "var(--ds-background-accent-red-bolder, #C9372C)"
};
const $95edbd031597fc42$var$bannerTextColors = {
    announcement: "var(--ds-text-inverse, #FFFFFF)",
    info: "var(--ds-text-inverse, #FFFFFF)",
    note: "var(--ds-text-inverse, #FFFFFF)",
    success: "var(--ds-text-inverse, #FFFFFF)",
    warning: "var(--ds-text, #292A2E)",
    error: "var(--ds-text-inverse, #FFFFFF)"
};
const $95edbd031597fc42$export$8c91c13eb4b58362 = {
    announcement: "var(--ds-icon-inverse, #FFFFFF)",
    info: "var(--ds-icon-inverse, #FFFFFF)",
    note: "var(--ds-icon-inverse, #FFFFFF)",
    success: "var(--ds-icon-inverse, #FFFFFF)",
    warning: "var(--ds-icon, #292A2E)",
    error: "var(--ds-icon-inverse, #FFFFFF)"
}; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $95edbd031597fc42$var$BannerContentParagraph = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_c71l1tcg _4t3i1wug _18m91wug _155a1rr0 _aayn1f0r _motwz6vj _1qf2ckbl _1atkglyw _1ke819bv",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $95edbd031597fc42$var$BannerContentWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { textColor: textColor, linkDisabled: linkDisabled, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1qrlcdp": (0, $7sObp.default)(__cmplp.textColor)
        },
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1reo15vq _18m915vq _16jlkb7n _1o9zkb7n _i0dlf1ug _18s8s8vo _59381r31 _yha28stv _1nmznqa1 _bpspwu06 _125xijt0 _43dsijt0 _p03cijt0 _oavvijt0 _oxk4ijt0 _1cayijt0",
            __cmplp.linkDisabled && "_ru7vglyw _5lhm73ad",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $95edbd031597fc42$var$Banner = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { background: background, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_8jvb0j": (0, $7sObp.default)(__cmplp.height),
            "--_146l9hq": (0, $7sObp.default)(__cmplp.background)
        },
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_11q71i36 _1yt4s8vo _1e0c1txw _4cvr1h6o _4t3i1474",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $95edbd031597fc42$var$DismissSpan = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { textColor: textColor, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1qrlcdp": (0, $7sObp.default)(__cmplp.textColor)
        },
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_syazijt0",
            __cmplp.className
        ])
    });
});
const $95edbd031597fc42$var$useBrowserMetric = ()=>{
    (0, $42omo.useEffect)(()=>{
        if ((0, $5Abqh.checkSSRPartialSuccess)((0, $5Abqh.SSR_PARTIAL_COMPONENT).AdminAnnouncementBanner)) (0, $3nZRM.ADMIN_ANNOUNCEMENT_BANNER_METRIC).markFMP((0, $9eE57.getMark)('CFP-63.ssr-ttr'));
    }, []);
};
const $95edbd031597fc42$var$dismissButtonTheme = (currentTheme, themeProps)=>{
    const { buttonStyles: buttonStyles, spinnerStyles: spinnerStyles } = currentTheme(themeProps);
    return {
        buttonStyles: {
            ...buttonStyles,
            backgroundColor: "var(--ds-background-inverse-subtle, #00000029)",
            '&:hover': {
                backgroundColor: "var(--ds-background-inverse-subtle-hovered, #0000003D)"
            },
            '&:active': {
                backgroundColor: "var(--ds-background-inverse-subtle-pressed, #00000052)"
            }
        },
        spinnerStyles: spinnerStyles
    };
};
const $95edbd031597fc42$export$7691a10e01045f1f = ({ onClick: onClick, content: content, appearance: appearance, isDismissible: isDismissible, onDismiss: onDismiss, userId: userId, cloudId: cloudId, onError: onError, onComplete: onComplete, interactive: interactive = true, shouldRenderMigratorPrompt: shouldRenderMigratorPrompt = false, isPreview: isPreview = false })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const providers = (0, $42omo.useMemo)(()=>{
        const emojiProvider = (0, $32x2E.getEmojiProvider)((0, $ibzAc.default), {
            cloudId: cloudId,
            userId: userId
        });
        return (0, $4FxUL.default).create({
            emojiProvider: emojiProvider
        });
    }, [
        userId,
        cloudId
    ]);
    $95edbd031597fc42$var$useBrowserMetric();
    const migratorPromptContent = (0, $7whYF.useMigratorPromptContent)();
    const ssrPlaceholderIdProp = (0, $luv00.useSSRPlaceholderReplaceIdProp)();
    const onRenderComplete = (0, $42omo.useCallback)((stat)=>{
        (0, $5Abqh.setSSRPartialSuccess)((0, $5Abqh.SSR_PARTIAL_COMPONENT).AdminAnnouncementBanner);
        onComplete && onComplete(stat);
    }, [
        onComplete
    ]);
    const displayContent = shouldRenderMigratorPrompt ? migratorPromptContent : content;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($95edbd031597fc42$var$Banner, {
        onClick: onClick,
        background: $95edbd031597fc42$export$1cd228c2a1902afd[appearance],
        height: `${(0, $ggElv.isBannerContentSingleLineFromDocNode)(displayContent) ? (0, $b3o7x.BANNER_HEIGHT_SINGLE_LINE) : (0, $b3o7x.BANNER_HEIGHT_MULTI_LINE)}px`,
        "data-vc": "admin-announcement-banner",
        "data-testid": "admin-announcement-banner-component",
        ...ssrPlaceholderIdProp,
        ...isPreview ? {} : {
            role: 'banner'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6fjxX))), {
        spacing: "spacious",
        label: "",
        color: $95edbd031597fc42$export$8c91c13eb4b58362[appearance]
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($95edbd031597fc42$var$BannerContentWrapper, {
        textColor: $95edbd031597fc42$var$bannerTextColors[appearance],
        linkDisabled: !interactive
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $67O0h.default), {
        document: displayContent,
        appearance: "comment",
        adfStage: "stage0",
        dataProviders: providers,
        nodeComponents: {
            paragraph: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($95edbd031597fc42$var$BannerContentParagraph, {
                    ...props.dataAttributes,
                    "data-local-id": props.localId,
                    "data-as-inline": props.asInline,
                    "data-vc": "admin-announcement-banner-content",
                    "data-vc-ignore-if-no-layout-shift": "true",
                    "data-multi-line": !(0, $ggElv.isCharacterCountSingleLine)((0, $aTfTn.getCharacterCount)(props.content))
                }, props.children)
        },
        onComplete: onRenderComplete,
        onError: onError
    })), isDismissible && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4KS7f.default), {
        spacing: "compact",
        "data-id": "ssr-dismiss-admin-announcement-button",
        onClick: onDismiss,
        isDisabled: !interactive,
        "aria-label": isPreview ? formatMessage($95edbd031597fc42$var$i18n.previewDismiss) : formatMessage($95edbd031597fc42$var$i18n.dismiss),
        theme: $95edbd031597fc42$var$dismissButtonTheme
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($95edbd031597fc42$var$DismissSpan, {
        textColor: $95edbd031597fc42$var$bannerTextColors[appearance],
        "data-vc": "dismiss-button-text"
    }, formatMessage($95edbd031597fc42$var$i18n.dismissText))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kvJHJ.PageSegmentLoadEnd), {
        metric: (0, $3nZRM.ADMIN_ANNOUNCEMENT_BANNER_METRIC)
    }));
};
module.exports["Appearance"] = $95edbd031597fc42$export$40bdb27f2137fcf;
module.exports["bannerBackgroundColors"] = $95edbd031597fc42$export$1cd228c2a1902afd;
module.exports["bannerIconColors"] = $95edbd031597fc42$export$8c91c13eb4b58362;
module.exports["AdminAnnouncementBannerComponent"] = $95edbd031597fc42$export$7691a10e01045f1f;

});

parcelRegister("aTfTn", function(module, exports) {

var $ks2lK = parcelRequire("ks2lK");


var $ftzrq = parcelRequire("ftzrq");

const $3ffd3d42effc8b8c$var$SPECIAL_NODES = [
    'media',
    'embedCard',
    'blockCard',
    'caption'
];
const $3ffd3d42effc8b8c$var$isBlock = (node)=>!!node.content;
const $3ffd3d42effc8b8c$var$isText = (node)=>node.type === 'text';
const $3ffd3d42effc8b8c$var$isInline = (node)=>!$3ffd3d42effc8b8c$var$isBlock(node) && !$3ffd3d42effc8b8c$var$isText(node) && node.type !== 'media';
const $3ffd3d42effc8b8c$var$isSpecial = (node)=>$3ffd3d42effc8b8c$var$SPECIAL_NODES.indexOf(node.type) !== -1;
const $3ffd3d42effc8b8c$export$a790a3f1405abd45 = (content)=>{
    return content.reduce((size, node)=>{
        if ($3ffd3d42effc8b8c$var$isSpecial(node)) return size;
        else if ($3ffd3d42effc8b8c$var$isBlock(node)) return size + $3ffd3d42effc8b8c$export$a790a3f1405abd45(node.content);
        else if ($3ffd3d42effc8b8c$var$isText(node)) return size + node.text.length;
        else if ($3ffd3d42effc8b8c$var$isInline(node) && node.type !== 'hardBreak') return size + 1;
        return size;
    }, 0);
};
const $3ffd3d42effc8b8c$export$1de1d5dcbaef40ef = (doc, maxContentSize)=>{
    let pos = 0;
    let characterCount = 0;
    let breakPointPosition = 0;
    function countNode(node) {
        if (characterCount === maxContentSize) breakPointPosition = pos;
        if (node.type.name === 'caption') // Count the size of the node (text content) + 1 for the node boundary itself.
        pos += (node.content?.size ?? 0) + 1;
        else if (node.isText && node.nodeSize) for(let i = 0; i < node.nodeSize; i++){
            if (characterCount === maxContentSize) breakPointPosition = pos;
            pos++;
            characterCount++;
        }
        else if (node.isInline) {
            pos++;
            if (node.type.name !== 'hardBreak') characterCount++;
        } else {
            if (node.type.name !== 'doc') pos++;
            for (const child of node.content?.content)countNode(child);
            if (node.type.name !== 'doc') pos++;
        }
    }
    countNode(doc);
    return {
        characterCount: characterCount,
        breakPointPosition: breakPointPosition
    };
};
class $3ffd3d42effc8b8c$export$d9e07de090952fe4 {
    subscribe(subscription) {
        this.subscriptions.push(subscription);
        subscription(this.lastChange);
        return ()=>this.subscriptions.filter((sub)=>sub === subscription);
    }
    change(state) {
        this.lastChange = state;
        for (const sub of this.subscriptions)sub(state);
    }
    constructor(){
        this.subscriptions = [];
        this.lastChange = void 0;
    }
}
class $3ffd3d42effc8b8c$var$ViewPlugin {
    update(view) {
        const pluginState = $3ffd3d42effc8b8c$export$df61b30b684217c0.getState(view.state);
        this.subscription.change(pluginState);
    }
    constructor(editorView, subscription){
        this.editorView = void 0;
        this.subscription = void 0;
        this.initialized = false;
        this.editorView = editorView;
        this.subscription = subscription;
    }
}
const $3ffd3d42effc8b8c$export$df61b30b684217c0 = new (0, $ks2lK.PluginKey)('content-overflow');
const $3ffd3d42effc8b8c$export$6be6cfaf2cc0431a = (maxContentSize)=>{
    const subscription = new $3ffd3d42effc8b8c$export$d9e07de090952fe4();
    const plugin = new (0, $ks2lK.Plugin)({
        key: $3ffd3d42effc8b8c$export$df61b30b684217c0,
        state: {
            init: ()=>({
                    isActive: false,
                    positions: {
                        characterCount: 0,
                        breakPointPosition: 0
                    }
                }),
            apply: (tr)=>{
                const positions = $3ffd3d42effc8b8c$export$1de1d5dcbaef40ef(tr.doc, maxContentSize);
                if (positions.characterCount > maxContentSize) return {
                    isActive: true,
                    positions: positions
                };
                return {
                    isActive: false,
                    positions: positions
                };
            }
        },
        props: {
            decorations (state) {
                const { doc: doc } = state;
                const { isActive: isActive, positions: positions } = $3ffd3d42effc8b8c$export$df61b30b684217c0.getState(state);
                if (isActive && positions) return (0, $ftzrq.DecorationSet).create(doc, [
                    (0, $ftzrq.Decoration).inline(positions.breakPointPosition, doc.nodeSize, {
                        class: 'editor-content-overflow',
                        'data-testId': 'editor-content-overflow'
                    })
                ]);
                return null;
            }
        },
        view (editorView) {
            return new $3ffd3d42effc8b8c$var$ViewPlugin(editorView, subscription);
        }
    });
    return {
        plugin: plugin,
        subscription: subscription
    };
};
module.exports["getCharacterCount"] = $3ffd3d42effc8b8c$export$a790a3f1405abd45;
module.exports["contentOverflowPlugin"] = $3ffd3d42effc8b8c$export$6be6cfaf2cc0431a;

});

parcelRegister("edve5", function(module, exports) {
const $299607e3bdf75059$export$d271b78bd5d35f13 = (content)=>{
    if (!content) return {};
    try {
        return JSON.parse(content);
    } catch  {
        // TODO: Add Experience Tracking here
        return {};
    }
};
module.exports["parseBannerContent"] = $299607e3bdf75059$export$d271b78bd5d35f13;

});

parcelRegister("2F3Ut", function(module, exports) {

var $lcuos = parcelRequire("lcuos");


var $aTfTn = parcelRequire("aTfTn");

const $45e360c90ea7f7af$export$5141155926a569f9 = 180;
const $45e360c90ea7f7af$export$838f61a7808fc04 = 4000;
const $45e360c90ea7f7af$export$6f57d41e71b5302c = 40;
var $45e360c90ea7f7af$export$f0e4a5ad335dc04f = /*#__PURE__*/ function(ContentValidationError) {
    ContentValidationError["INVALID_NODE"] = "invalidNode";
    ContentValidationError["EMPTY"] = "empty";
    ContentValidationError["CHARACTER_OVERFLOW"] = "characterOverflow";
    return ContentValidationError;
}({});
var $45e360c90ea7f7af$export$e7cb516b2ee0838 = /*#__PURE__*/ function(SchedulingValidationError) {
    SchedulingValidationError["START_AFTER_END_DATE"] = "startAfterEndDate";
    SchedulingValidationError["START_AFTER_END_TIME"] = "startAfterEndTime";
    SchedulingValidationError["END_BEFORE_START_DATE"] = "endBeforeStartDate";
    SchedulingValidationError["END_BEFORE_START_TIME"] = "endBeforeStartTime";
    SchedulingValidationError["START_DATE_CONFLICT"] = "startDateConflict";
    SchedulingValidationError["START_TIME_CONFLICT"] = "startTimeConflict";
    SchedulingValidationError["END_DATE_CONFLICT"] = "endDateConflict";
    SchedulingValidationError["END_TIME_CONFLICT"] = "endTimeConflict";
    return SchedulingValidationError;
}({});
const $45e360c90ea7f7af$export$8b4e216a07e71160 = (value)=>{
    if (!value || value.length === 0 || !value.replace(/\s/g, '').length) return 'empty';
    return undefined;
};
const $45e360c90ea7f7af$export$1fbd44e8a75e17b6 = (adfDoc)=>{
    if (!adfDoc?.content) return "empty";
    if (adfDoc.content.length !== 1 || adfDoc.content[0].type !== 'paragraph') return "invalidNode";
    if (!adfDoc.content[0].content) return "empty";
    const characterCount = (0, $aTfTn.getCharacterCount)(adfDoc.content);
    if (characterCount == 0) return "empty";
    // when text is all whitespaces, the content is considered empty
    const texts = (0, $lcuos.filter)(adfDoc, (node)=>node.type === 'text');
    if (texts.length === 1 && texts[0].text.trim().length === 0) return "empty";
    if (characterCount > $45e360c90ea7f7af$export$838f61a7808fc04) return "characterOverflow";
    return null;
};
module.exports["MAX_CONTENT_CHARACTER_COUNT_SINGLE_LINE"] = $45e360c90ea7f7af$export$5141155926a569f9;
module.exports["MAX_TOTAL_CONTENT_CHARACTER_COUNT"] = $45e360c90ea7f7af$export$838f61a7808fc04;
module.exports["MAX_TITLE_CHARACTER_COUNT"] = $45e360c90ea7f7af$export$6f57d41e71b5302c;
module.exports["ContentValidationError"] = $45e360c90ea7f7af$export$f0e4a5ad335dc04f;
module.exports["validateTitle"] = $45e360c90ea7f7af$export$8b4e216a07e71160;
module.exports["validateContent"] = $45e360c90ea7f7af$export$1fbd44e8a75e17b6;

});

parcelRegister("3nZRM", function(module, exports) {

var $lSOAM = parcelRequire("lSOAM");

var $fQ3iN = parcelRequire("fQ3iN");


var $jX1qB = parcelRequire("jX1qB");

var $1UCmC = parcelRequire("1UCmC");

const $7543aa9f533dc7ef$export$3fda5980a9485f2c = (0, $fQ3iN.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.ADMIN_ANNOUNCEMENT_BANNER_SEGMENT_KEY),
    ssr: Boolean(window.__SSR_RENDERED__) ? {
        doneAsFmp: true
    } : undefined
});
const $7543aa9f533dc7ef$export$92f82c80b88a3740 = (0, $lSOAM.createPageLoadMetric)({
    key: (0, $1UCmC.ADMIN_ANNOUNCEMENT_BANNER_SETTING_PAGE_LOAD_KEY)
});
module.exports["ADMIN_ANNOUNCEMENT_BANNER_METRIC"] = $7543aa9f533dc7ef$export$3fda5980a9485f2c;

});

parcelRegister("7whYF", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

// i18n messages
const $21267215b353282d$var$i18n = (0, $aXWIB.defineMessages)({
    promptContentText: {
        id: "admin-announcement-banner.migrator-prompt.content",
        defaultMessage: "Guess what, admins? You can use an announcement banner like this one to communicate important messages to all of your users at once."
    },
    promptLinkText: {
        id: "admin-announcement-banner.migrator-prompt.link",
        defaultMessage: "Create announcement banner"
    }
});
const $21267215b353282d$export$58b7ce9895c4f4b3 = {
    id: 'migratorPrompt',
    isDismissible: true,
    appearance: 'note',
    title: 'Migrator Prompt AAB',
    updatedAt: new Date().toUTCString(),
    content: ''
};
const $21267215b353282d$export$77f5e9ef031ee74c = ()=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    return {
        version: 1,
        type: 'doc',
        content: [
            {
                type: 'paragraph',
                content: [
                    {
                        type: 'text',
                        text: formatMessage($21267215b353282d$var$i18n.promptContentText)
                    },
                    {
                        type: 'text',
                        text: ' '
                    },
                    {
                        type: 'text',
                        text: formatMessage($21267215b353282d$var$i18n.promptLinkText),
                        marks: [
                            {
                                type: 'link',
                                attrs: {
                                    href: '/wiki/admin/announcements'
                                }
                            }
                        ]
                    },
                    {
                        type: 'text',
                        text: '.'
                    }
                ]
            }
        ]
    };
};
module.exports["migratorPromptWithEmptyContent"] = $21267215b353282d$export$58b7ce9895c4f4b3;
module.exports["useMigratorPromptContent"] = $21267215b353282d$export$77f5e9ef031ee74c;

});

parcelRegister("b3o7x", function(module, exports) {

var $iwZYw = parcelRequire("iwZYw");


var $cbc8g = parcelRequire("cbc8g");


var $jMyy4 = parcelRequire("jMyy4");


var $bQm3c = parcelRequire("bQm3c");



var $ggElv = parcelRequire("ggElv");


var $42omo = parcelRequire("42omo");


var $6mKj3 = parcelRequire("6mKj3");


var $17wUi = parcelRequire("17wUi");


var $1UApO = parcelRequire("1UApO");

const $64079b265b1815c2$var$ADMIN_ANNOUNCEMENT_BANNER_DISMISS_STATE_KEY = 'admin.announcement.banner';
const $64079b265b1815c2$var$PERSISTED_ADMIN_ANNOUNCEMENT_BANNER_DISMISS_STATE_KEY = (0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_ADMIN_ANNOUNCEMENT_BANNER;
const $64079b265b1815c2$export$190f48575cfcbb2e = ({ cachedUpdatedAt: cachedUpdatedAt, updatedAt: updatedAt, isDismissible: isDismissible })=>{
    if (!updatedAt) return false;
    if (!isDismissible && (0, $6mKj3.isExperimentEnabled)('confluence_aab_client_side_dismissible_check')) return false;
    return cachedUpdatedAt === updatedAt;
};
const $64079b265b1815c2$export$ddfe3dfde4221f96 = ({ isLicensed: isLicensed, id: id, updatedAt: updatedAt, isDismissible: isDismissible })=>{
    const { storage: storage, dismissStateKey: dismissStateKey, initialUpdatedAt: initialUpdatedAt } = (0, $42omo.useMemo)(()=>{
        if (!isLicensed) return {
            storage: (0, $17wUi.confluenceSessionStorageInstance),
            dismissStateKey: $64079b265b1815c2$var$ADMIN_ANNOUNCEMENT_BANNER_DISMISS_STATE_KEY
        };
        return {
            storage: (0, $17wUi.confluenceLocalStorageInstance),
            dismissStateKey: $64079b265b1815c2$var$PERSISTED_ADMIN_ANNOUNCEMENT_BANNER_DISMISS_STATE_KEY,
            initialUpdatedAt: (0, $17wUi.confluenceLocalStorageInstance)?.getItem($64079b265b1815c2$var$PERSISTED_ADMIN_ANNOUNCEMENT_BANNER_DISMISS_STATE_KEY)?.updatedAt
        };
    }, [
        isLicensed
    ]);
    const [isDismissed, setIsDismissed] = (0, $42omo.useState)($64079b265b1815c2$export$190f48575cfcbb2e({
        cachedUpdatedAt: initialUpdatedAt,
        updatedAt: updatedAt,
        isDismissible: isDismissible
    }));
    (0, $42omo.useEffect)(()=>{
        if (updatedAt) {
            const cachedUpdatedAt = storage.getItem(dismissStateKey)?.updatedAt;
            setIsDismissed($64079b265b1815c2$export$190f48575cfcbb2e({
                cachedUpdatedAt: cachedUpdatedAt,
                updatedAt: updatedAt,
                isDismissible: isDismissible
            }));
        }
    }, [
        dismissStateKey,
        storage,
        updatedAt,
        isDismissible
    ]);
    const onDismiss = ()=>{
        storage.setItem(dismissStateKey, {
            id: id,
            updatedAt: updatedAt
        });
        const cachedUpdatedAt = storage.getItem(dismissStateKey)?.updatedAt;
        setIsDismissed($64079b265b1815c2$export$190f48575cfcbb2e({
            cachedUpdatedAt: cachedUpdatedAt,
            updatedAt: updatedAt,
            isDismissible: isDismissible
        }));
    };
    return {
        isDismissed: isDismissed,
        onDismiss: onDismiss
    };
};



var $lfcs7 = parcelRequire("lfcs7");

/**
 * @generated SignedSource<<888ab3afbf8d213f12633cb40128b138>>
 * @relayHash f25f6c69f7df3cc8b9f619a0b3dea87f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 55ec1cf07f5468a3729ecf270bd81bf035b3c010d9d2c523421d6d43d8857f55
const $1b965e498fc96e85$var$node = function() {
    var v0 = [
        {
            "args": [
                {
                    "kind": "Literal",
                    "name": "first",
                    "value": 1
                },
                {
                    "kind": "Literal",
                    "name": "isAscending",
                    "value": false
                },
                {
                    "kind": "Literal",
                    "name": "orderBy",
                    "value": "DEFAULT"
                }
            ],
            "concreteType": "AdminAnnouncementBannerSettingConnection",
            "kind": "LinkedField",
            "name": "adminAnnouncementBannerSettingsByCriteria",
            "plural": false,
            "selections": [
                {
                    "concreteType": "ConfluenceAdminAnnouncementBannerSetting",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        }
                    ]
                }
            ],
            "storageKey": "adminAnnouncementBannerSettingsByCriteria(first:1,isAscending:false,orderBy:\"DEFAULT\")"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "useMigratorPromptEligibleAABMigratorPromptQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "useMigratorPromptEligibleAABMigratorPromptQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "f25f6c69f7df3cc8b9f619a0b3dea87f",
            "id": "55ec1cf07f5468a3729ecf270bd81bf035b3c010d9d2c523421d6d43d8857f55",
            "metadata": {},
            "name": "useMigratorPromptEligibleAABMigratorPromptQuery",
            "operationKind": "query",
            "text": "query useMigratorPromptEligibleAABMigratorPromptQuery{adminAnnouncementBannerSettingsByCriteria(first:1,orderBy:DEFAULT,isAscending:false){nodes{id}}}"
        }
    };
}();
$1b965e498fc96e85$var$node.hash = "bd3194ed3bdf2af28565248ad52e5bea";
var $1b965e498fc96e85$export$2e2bcd8739ae039 = $1b965e498fc96e85$var$node;






var $4TIFs = parcelRequire("4TIFs");

var $cTaz1 = parcelRequire("cTaz1");


var $inPa6 = parcelRequire("inPa6");


var $3IBnw = parcelRequire("3IBnw");


var $5ZqQS = parcelRequire("5ZqQS");


var $1ytiN = parcelRequire("1ytiN");





var $kAcNG = parcelRequire("kAcNG");


var $7Sm4c = parcelRequire("7Sm4c");




const $38bcfa352fadc3f0$export$c11d6399d45a6d8e = ({ skip: skip = false } = {})=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    // Feature and role checks
    const { isSiteAdmin: isSiteAdmin } = (0, $42omo.useContext)((0, $1ytiN.SPAViewContext));
    const shouldSkip = skip || !isSiteAdmin;
    // Session data
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    // Query for AABTableData
    const { data: AABTableData, loading: AABTableLoading, error: AABTableError } = (0, $jMyy4.useQueryInterop)((0, $1b965e498fc96e85$export$2e2bcd8739ae039), {
        skip: shouldSkip,
        __callerPackage__: "@confluence/admin-announcement-banner"
    });
    // Query for site personalization data
    const { attributes: attributes, loading: sitePersonalizationLoading, error: sitePersonalizationError } = (0, $kAcNG.useSitePersonalizationQuery)({
        cloudId: cloudId,
        skip: shouldSkip
    });
    // Processing site personalization data
    const sitePersonalizationDataAttributes = attributes?.reduce((obj, item)=>({
            ...obj,
            [item.name]: item.value
        }), {});
    // Migration date calculations
    const migrationCompletionDate = sitePersonalizationDataAttributes?.['confluence_site_migration_completion_date'];
    const dateSixMonthsAfterMigration = migrationCompletionDate ? (0, $4TIFs.default)(new Date(migrationCompletionDate), 6) : undefined;
    const isWithinSixMonthsAfterMigration = dateSixMonthsAfterMigration ? (0, $cTaz1.default)(dateSixMonthsAfterMigration) : false;
    // Final loading and error states
    const loading = AABTableLoading || sitePersonalizationLoading;
    const error = (0, $42omo.useMemo)(()=>AABTableError || sitePersonalizationError, [
        AABTableError,
        sitePersonalizationError
    ]);
    (0, $42omo.useEffect)(()=>{
        // Error handling
        if (error) {
            (0, $5ZqQS.getMonitoringClient)().submitError(error, {
                attribution: (0, $3IBnw.Attribution).ADMIN_EXPERIENCE
            });
            (0, $7Sm4c.markErrorAsHandled)(error);
        }
    }, [
        createAnalyticsEvent,
        error
    ]);
    // Check for existing admin announcement banners
    const hasAdminAnnouncementBanners = !!AABTableData?.adminAnnouncementBannerSettingsByCriteria?.nodes?.length;
    // Eligibility check
    const isMigratorPromptEligible = !shouldSkip && !loading && !error && isWithinSixMonthsAfterMigration && !hasAdminAnnouncementBanners;
    return {
        isMigratorPromptEligible: isMigratorPromptEligible,
        loading: loading
    };
};











const $c90874ba014deca9$var$getIsDismissed = ()=>{
    return String((0, $17wUi.confluenceLocalStorageInstance)?.getItem((0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_ADMIN_ANNOUNCEMENT_BANNER_MIGRATOR_PROMPT)) === 'true';
};
const $c90874ba014deca9$export$5c850f92272172a0 = ()=>{
    const [isDismissed, setIsDismissed] = (0, $42omo.useState)($c90874ba014deca9$var$getIsDismissed);
    const onDismiss = (0, $42omo.useCallback)(()=>{
        (0, $17wUi.confluenceLocalStorageInstance).setItem((0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_ADMIN_ANNOUNCEMENT_BANNER_MIGRATOR_PROMPT, 'true');
        setIsDismissed(true);
    }, []);
    return {
        isDismissed: isDismissed,
        onDismiss: onDismiss
    };
};


const $bd0a0478746facd6$var$adminAnnouncementBannerQuery = (0, $iwZYw.default);
const $bd0a0478746facd6$var$BANNER_NAME = 'AdminAnnouncementBanner';
const $bd0a0478746facd6$export$5e1a452907b75ede = 48;
const $bd0a0478746facd6$export$c5ed19fdc04bdcfd = 72;
function $bd0a0478746facd6$export$bca949e2a02e745b(bannerState = null) {
    const { isLicensed: isLicensed } = (0, $bQm3c.useSessionData)();
    const isPageEligibleForAdminAnnouncementBanner = (0, $lfcs7.useIsPageEligibleForAdminAnnouncementBanner)();
    const { data: data, loading: activeAnnouncementBannerLoading, error: activeAnnouncementBannerError } = (0, $jMyy4.useQueryInterop)($bd0a0478746facd6$var$adminAnnouncementBannerQuery, {
        skip: !isPageEligibleForAdminAnnouncementBanner,
        __callerPackage__: "@confluence/admin-announcement-banner"
    });
    const hasOtherBanners = isPageEligibleForAdminAnnouncementBanner && (bannerState?.state?.banners?.some((banner)=>banner.name !== $bd0a0478746facd6$var$BANNER_NAME) || undefined);
    // Migrator prompt eligibility
    const { isMigratorPromptEligible: isMigratorPromptEligible, loading: migratorPromptEligibleLoading } = (0, $38bcfa352fadc3f0$export$c11d6399d45a6d8e)({
        skip: // No SSR support for migrator prompt
        // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
        Boolean(undefined) || // Contextual eligibility check
        !isPageEligibleForAdminAnnouncementBanner || hasOtherBanners || // Existing active AAB Query
        activeAnnouncementBannerLoading || Boolean(data?.adminAnnouncementBanner)
    });
    // Dismissal state
    const migratorPromptDismissalState = (0, $c90874ba014deca9$export$5c850f92272172a0)();
    const adminAnnouncementDismissalState = (0, $64079b265b1815c2$export$ddfe3dfde4221f96)({
        isLicensed: isLicensed,
        id: data?.adminAnnouncementBanner?.id,
        updatedAt: data?.adminAnnouncementBanner?.updatedAt,
        isDismissible: data?.adminAnnouncementBanner?.isDismissible
    });
    const { isDismissed: isDismissed, onDismiss: onDismiss } = isMigratorPromptEligible ? migratorPromptDismissalState : adminAnnouncementDismissalState;
    const loading = activeAnnouncementBannerLoading || migratorPromptEligibleLoading;
    // Banner rendering conditions
    const bannerHasContent = Boolean(data?.adminAnnouncementBanner) || isMigratorPromptEligible;
    const isBannerReadyToDisplay = !loading && !hasOtherBanners && !isDismissed;
    const shouldRender = bannerHasContent && isBannerReadyToDisplay;
    const shouldRenderMigratorPrompt = isMigratorPromptEligible && isBannerReadyToDisplay;
    if (shouldRender) {
        const bannerHeight = (0, $ggElv.isBannerContentSingleLineFromJSONString)(data?.adminAnnouncementBanner?.content || '') ? $bd0a0478746facd6$export$5e1a452907b75ede : $bd0a0478746facd6$export$c5ed19fdc04bdcfd;
        bannerState?.show($bd0a0478746facd6$var$BANNER_NAME, bannerHeight);
        (0, $cbc8g.addUFOCustomData)({
            isAdminAnnouncementBannerDisplayed: true
        });
    } else bannerState?.hide($bd0a0478746facd6$var$BANNER_NAME);
    return {
        shouldRender: shouldRender,
        hasOtherBanners: hasOtherBanners,
        onDismiss: onDismiss,
        data: data,
        loading: loading,
        error: activeAnnouncementBannerError,
        shouldRenderMigratorPrompt: shouldRenderMigratorPrompt
    };
}
module.exports["BANNER_HEIGHT_SINGLE_LINE"] = $bd0a0478746facd6$export$5e1a452907b75ede;
module.exports["BANNER_HEIGHT_MULTI_LINE"] = $bd0a0478746facd6$export$c5ed19fdc04bdcfd;
module.exports["useRegisterAdminAnnouncementBanner"] = $bd0a0478746facd6$export$bca949e2a02e745b;

});

parcelRegister("bf6dp", function(module, exports) {

var $lcuos = parcelRequire("lcuos");

const $fd87e14232173bbd$export$8054dcb2b42da45c = (content)=>{
    return (0, $lcuos.filter)(content, (node)=>(node.marks || []).some((mark)=>mark.type === 'link'));
};
module.exports["getLinks"] = $fd87e14232173bbd$export$8054dcb2b42da45c;

});

parcelRegister("k4L5H", function(module, exports) {

var $lcuos = parcelRequire("lcuos");

const $a3bffba19812fc90$export$86486c8fe8ccf3c8 = (content)=>{
    return (0, $lcuos.filter)(content, (node)=>node.type === 'emoji');
};
module.exports["getEmojis"] = $a3bffba19812fc90$export$86486c8fe8ccf3c8;

});

parcelRegister("b1yeC", function(module, exports) {

var $422HI = parcelRequire("422HI");


var $aMcHK = parcelRequire("aMcHK");

const $d45b7948f76d4f62$export$383b28711fd03459 = (error)=>{
    if (!error) return true;
    const statusCode = (0, $422HI.isApolloError)(error) ? (0, $aMcHK.getStatusCode)(error?.graphQLErrors?.[0]) : (0, $aMcHK.getStatusCode)(error);
    if (!statusCode) return true;
    return !!(parseInt(statusCode) >= 400 && parseInt(statusCode) < 500);
};
module.exports["shouldMarkErrorAsHandled"] = $d45b7948f76d4f62$export$383b28711fd03459;

});

parcelRegister("ggElv", function(module, exports) {

var $aTfTn = parcelRequire("aTfTn");


var $edve5 = parcelRequire("edve5");


var $2F3Ut = parcelRequire("2F3Ut");

const $d88a28955c113d5e$export$a83aabc889425c77 = (characterCount)=>characterCount <= (0, $2F3Ut.MAX_CONTENT_CHARACTER_COUNT_SINGLE_LINE);
const $d88a28955c113d5e$export$501bebf9e0446b0c = (docNode)=>{
    // DocNode with an empty content property corresponds with empty banner content, which is valid and is a single line
    if (!docNode.content) return true;
    const nodes = docNode.content;
    const characterCount = (0, $aTfTn.getCharacterCount)(nodes);
    return $d88a28955c113d5e$export$a83aabc889425c77(characterCount);
};
const $d88a28955c113d5e$export$c8060b39d14b868e = (content)=>{
    const docNode = (0, $edve5.parseBannerContent)(content);
    return $d88a28955c113d5e$export$501bebf9e0446b0c(docNode);
};
module.exports["isCharacterCountSingleLine"] = $d88a28955c113d5e$export$a83aabc889425c77;
module.exports["isBannerContentSingleLineFromDocNode"] = $d88a28955c113d5e$export$501bebf9e0446b0c;
module.exports["isBannerContentSingleLineFromJSONString"] = $d88a28955c113d5e$export$c8060b39d14b868e;

});


//# sourceMappingURL=AdminAnnouncementBannerInner.6f591ed3.js.map
